export const businessInfo = {
  name: "Om Sai Express",
  tagline: "Reliable Courier & Logistics Solutions",
  logoUrl: "/logo.png",
  address: "F-269, Mansarovar Garden, New Delhi – 110015",
  phone: "011-45789249",
  whatsapp: "+91 9873849129",
  whatsappLink: "https://wa.me/919873849129",
  email: "prashantbhardwaj1245@gmail.com",
  website: "omsaiexpress.in",
  gstin: "07BLVPK0261L1ZO",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.1234567890!2d77.1234567!3d28.6345678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sMansarovar%20Garden%2C%20New%20Delhi!5e0!3m2!1sen!2sin!4v1234567890",
};

export const services = [
  {
    id: 1,
    title: "Domestic Courier Services",
    description: "Reliable and affordable domestic courier delivery across all major cities and towns in India. We ensure your packages reach their destination safely and on time.",
    icon: "Package",
  },
  {
    id: 2,
    title: "Express & Time-Critical Delivery",
    description: "When time matters most, our express delivery service guarantees fast and priority handling of your shipments with real-time tracking.",
    icon: "Clock",
  },
  {
    id: 3,
    title: "Document & Parcel Shipping",
    description: "Secure and careful handling of important documents and parcels. From legal papers to personal documents, we treat every shipment with utmost care.",
    icon: "FileText",
  },
  {
    id: 4,
    title: "Business & Commercial Shipments",
    description: "Tailored solutions for businesses requiring regular commercial shipments. Bulk rates, dedicated support, and reliable schedules for your business needs.",
    icon: "Building2",
  },
  {
    id: 5,
    title: "Door-to-Door Pickup & Delivery",
    description: "Convenient doorstep pickup and delivery service. Just call or WhatsApp us to schedule a pickup from your location.",
    icon: "Truck",
  },
];

export const courierPartners = [
  {
    id: 1,
    name: "Trackon",
    description: "One of India's leading courier and cargo companies with a vast network covering 28,000+ pin codes. Known for their express delivery and reliable service.",
    coverage: "Pan-India Coverage",
    specialty: "Express Delivery & Cargo",
  },
  {
    id: 2,
    name: "Shree Maruti",
    description: "A trusted name in Indian courier industry with strong presence across the country. Known for surface and air express services.",
    coverage: "Pan-India Coverage",
    specialty: "Surface & Air Express",
  },
  {
    id: 3,
    name: "Delhivery",
    description: "India's largest fully integrated logistics company providing reliable supply chain solutions with advanced technology and tracking.",
    coverage: "Pan-India & International",
    specialty: "Technology-Driven Logistics",
  },
];

export const heroStats = [
  { label: "Cities Covered", value: "500+" },
  { label: "Pin Codes Served", value: "28,000+" },
  { label: "Happy Customers", value: "10,000+" },
  { label: "Years of Service", value: "10+" },
];

export const whyChooseUs = [
  {
    title: "Safe & Secure Delivery",
    description: "Every package is handled with care and tracked throughout its journey.",
    icon: "ShieldCheck",
  },
  {
    title: "Affordable Rates",
    description: "Competitive pricing without compromising on service quality.",
    icon: "IndianRupee",
  },
  {
    title: "Timely Delivery",
    description: "We value your time and ensure on-time delivery every time.",
    icon: "Timer",
  },
  {
    title: "Multiple Partners",
    description: "We work with top courier companies to give you the best options.",
    icon: "Handshake",
  },
];

export const contactFormFields = [
  { name: "fullName", label: "Full Name", type: "text", placeholder: "Enter your full name", required: true },
  { name: "phone", label: "Phone Number", type: "tel", placeholder: "Enter your phone number", required: true },
  { name: "email", label: "Email Address", type: "email", placeholder: "Enter your email", required: false },
  { name: "pickupAddress", label: "Pickup Address", type: "textarea", placeholder: "Enter pickup address", required: false },
  { name: "message", label: "Message / Inquiry", type: "textarea", placeholder: "Describe your requirement...", required: true },
];
